import { Link } from "react-router-dom";

export function Logo({ light = false, className = "" }) {
  const textColor = light ? "text-white" : "text-[#0A192F]";
  return (
    <Link to="/" className={`flex items-center gap-2.5 group ${className}`} data-testid="site-logo">
      <span className="inline-flex items-center justify-center h-9 w-9 rounded-[6px] bg-[#12B6CF] shadow-sm">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 12.5L9.5 18L20 6.5" stroke="white" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      </span>
      <span className="leading-none">
        <span className={`block font-display font-extrabold tracking-tight text-[15px] ${textColor}`}>
          Tell Solihull
        </span>
        <span className={`block text-[10px] font-semibold uppercase tracking-[0.18em] ${light ? "text-cyan-300" : "text-[#0A788A]"}`}>
          Reform UK · Solihull
        </span>
      </span>
    </Link>
  );
}
